import { render } from "./TripleSystemAnalyticsResultsTable.vue?vue&type=template&id=beb246ec&scoped=true&ts=true"
import script from "./TripleSystemAnalyticsResultsTable.vue?vue&type=script&lang=ts"
export * from "./TripleSystemAnalyticsResultsTable.vue?vue&type=script&lang=ts"

import "./TripleSystemAnalyticsResultsTable.vue?vue&type=style&index=0&id=beb246ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beb246ec"]])

export default __exports__